import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { currentVisit, error } from '../store/state';
import { ensureVisitLoaded, cancelarVisita } from '../store/actions/visit.actions';
import { Shell } from '../layout/Shell';
import { fmt } from '../utils/format';

interface Props {
  id: string;
}

export function CancelarVisitaView({ id }: Props) {
  useEffect(() => {
    ensureVisitLoaded(id);
  }, [id]);

  const v = currentVisit.value;
  if (!v) return <Shell tab="agenda">{null}</Shell>;

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    try {
      await cancelarVisita(v.id, String(fd.get('motivo')));
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="agenda">
      <h2>Cancelar visita</h2>
      <div class="card">
        <strong>{v.client?.nombre}</strong>
        <p class="muted">Programada: {fmt(v.fechaProgramada)}</p>
      </div>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Motivo de cancelación</label>
        <textarea name="motivo" required placeholder="Ej: Cliente ya no requiere el servicio" />
        <button class="danger-outline" type="submit">
          Confirmar cancelación
        </button>
        <button class="secondary" type="button" onClick={() => route(`/visitas/${v.id}`)}>
          Volver
        </button>
      </form>
    </Shell>
  );
}
